<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add address"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :rules="rules" :model="addForm" @keydown.enter.native.prevent>
                <el-col :span="24">
                    <el-form-item label="Name" size="small" prop="name">
                        <el-input
                            clearable
                            size="small"
                            v-model="addForm.name"
                            placeholder="Firstname"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Street Address" size="small" prop="street1">
                        <el-input
                            clearable
                            size="small"
                            v-model="addForm.street1"
                            placeholder="Street1"
                        ></el-input>
                        <el-input
                            clearable
                            size="small"
                            v-model="addForm.street2"
                            placeholder="Street2"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Country" size="small" prop="country">
                        <el-select
                            v-model="addForm.country"
                            size="mini"
                            placeholder="Please select"
                            filterable
                            clearable
                        >
                            <el-option
                                v-for="item in countryList"
                                :key="item.id"
                                :label="item.name_en"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="State/Province" size="small" prop="state">
                        <el-input
                            clearable
                            size="small"
                            v-model="addForm.state"
                            placeholder="State/Province"
                        ></el-input>
                        <!-- <el-select
              v-model="addForm.state"
              size="mini"
              placeholder="Please select"
              filterable
              clearable
            >
              <el-option
                v-for="item in []"
                :key="item.id"
                :label="item.code"
                :value="item.code"
              ></el-option>
                        </el-select>-->
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="City" size="small" prop="city">
                        <el-input clearable size="small" v-model="addForm.city" placeholder="City"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Zip/Postal Code" size="small" prop="postal_code">
                        <el-input
                            clearable
                            size="small"
                            v-model="addForm.postal_code"
                            placeholder="Postal Code"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Phone Number" size="small" prop="Phone">
                        <el-input
                            clearable
                            size="small"
                            v-model="addForm.phone"
                            placeholder="Phone"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item size="small">
                        <el-checkbox
                            v-model="addForm.default"
                            checked
                            :true-label="1"
                            :false-label="0"
                            label="Set as default address"
                        ></el-checkbox>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save" :loading="loading">Save</el-button>
            <el-button size="small" @click="addVisible = false">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                name: "",
                country: "",
                state: "",
                city: "",
                street1: "",
                street2: "",
                phone: "",
                email: "",
                postal_code: "",
                house_number: "",
                default: 1,
                tag: ""
            },
            rules: {
                name: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                street1: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                country: [
                    {
                        required: true,
                        trigger: "change"
                    }
                ],
                state: [
                    {
                        required: false,
                        trigger: "change"
                    }
                ],
                city: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                postal_code: [
                    {
                        required: true,
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: false,
                        trigger: "blur"
                    }
                ]
            },
            loading: false,
            countryList: []
        };
    },
    methods: {
        ...mapActions(["getCountrySelect"]),
        save() {
                   /*  console.log(this.addForm);
                    return */
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .userAddress(
                            {
                                ...this.addForm,
                            },
                            "post"
                        )
                        .then(res => {
                            if (res) {
                                this.loading = false;
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "新增成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] && this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        closeDialog() {
            this.addForm = {};
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
            this.$parent.$options.name === "Home" && this.$parent.showaddresslist();
            this.loading = false;
        },
        async initialize() {
            this.getCountrySelect().then(res => {
                this.countryList = res.data;
            });
        }
    },
    props: {
        addVisible: Boolean,
        funcName: String
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
                this.initialize();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
    }
    
}
</style>
